export interface PhantomProvider {
  isPhantom?: boolean;
  isConnected?: boolean;
  publicKey?: { toBase58: () => string; toBytes: () => Uint8Array };
  connect: (opts?: { onlyIfTrusted?: boolean }) => Promise<{ publicKey: { toBase58: () => string } }>;
  disconnect: () => Promise<void>;
  signMessage: (
    message: Uint8Array,
    display?: string
  ) => Promise<{ signature: Uint8Array }>;
  on?: (event: 'connect' | 'disconnect' | 'accountChanged', handler: (...args: unknown[]) => void) => void;
  off?: (event: 'connect' | 'disconnect' | 'accountChanged', handler: (...args: unknown[]) => void) => void;
}

declare global {
  interface Window {
    phantom?: { solana?: PhantomProvider };
    solana?: PhantomProvider;
  }
}

/** Resolve Phantom injected provider (`window.phantom.solana` only). */
export function getPhantomProvider(): PhantomProvider | null {
  if (typeof window === 'undefined') return null;

  const provider = window.phantom?.solana;
  return provider?.isPhantom ? provider : null;
}

export function isPhantomAvailable(): boolean {
  return getPhantomProvider() != null;
}
